var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.name,staticClass:"content-field",class:[_vm.wrapperStyle.class],style:([_vm.wrapperStyle.style])},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }